/* eslint-disable import/prefer-default-export */

const createDatadogMetricData = ({ name, tags, value }) => ({
  api_token: process.env.NEXT_PUBLIC_DD_SERVICE_API_TOKEN,
  metricName: `app.chameleon.${name}`, // we only send in production
  value, // some metrics may not require a value
  tags: {
    origin_id: process.env.NEXT_PUBLIC_SUBMISSION_ORIGIN_ID, // i.e. "chameleon"
    ...tags, // responsibility of the caller to ensure that the tags are correct
  },
});

const createIncrementDatadogMetricData = ({ name, tags }) =>
  createDatadogMetricData({ name, tags, value: 1 });

export const incrementMetric = ({ name, tags }) => {
  if (process.env.NEXT_PUBLIC_SEND_DD_METRICS !== 'true') {
    return;
  }

  const datadogMetrics = createIncrementDatadogMetricData({
    name,
    tags,
  });

  fetch(`${process.env.NEXT_PUBLIC_DD_METRIC_URL}increment`, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(datadogMetrics),
  });
};
